import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import rulesImage from "../../assets/images/actsRulesOrder/rules.svg";
import DataLoader from "../../components/loader/dataLoader";
import "../../assets/css/adminPages/actRulesOrder/style.scss";
import useActsRulesAndOrders from "../../hooks/admin/useActsRulesAndOrders";

const Index = () => {
  const {
    modalCloseIconButton,
    handleModalTittleChange,
    demoObj,
    handleModalFileUpload,
    handleAdd,
    handleUpdate,
    isLoading,
    data,
    getData,
    hasMore,
    handleDelete,
    handleTittleChange,
    handleFileUpload,
    handleCloseModal,
    fileInputRef,
    titleInputRef
  } = useActsRulesAndOrders();

  return (
      <section className="acts-rules-orders-update-section">
        <div className="custom-container">
          <div className="content-section">
            <h1 className="page-title">ACTs, Rules & Orders</h1>
            <div className="content-body">
              <div className="pb-5 pb-lg-4 px-4 text-right">
                <button
                    type="button"
                    className="add-btn"
                    data-toggle="modal"
                    data-target="#exampleModal"
                >
                  Add Acts Rules Orders +
                </button>
                <div
                    className="modal fade"
                    data-backdrop="static"
                    data-keyboard="false"
                    id="exampleModal"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Add Acts Rules Orders
                        </h5>
                        <button
                            ref={modalCloseIconButton}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={handleCloseModal}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="custom-act-rules-order-card mx-auto">
                          <div className="card-header">
                            <img src={rulesImage} alt="Rules Icon"/>
                          </div>
                          <div className="card-body d-block text-left">
                            <div className="form__div-container w-100 mb-0">
                              <div className="form__div">
                                <input
                                    ref={titleInputRef}
                                    required
                                    type="text"
                                    name="titleEn"
                                    id="titleEn"
                                    className="form__input"
                                    placeholder=" "
                                    maxLength="100"
                                    onChange={handleModalTittleChange}
                                    value={demoObj.titleEn}
                                />
                                <label htmlFor="" className="form__label">
                                  Title
                                </label>
                              </div>
                            </div>
                            <div className="form__div-container w-100 my-3">
                              <div className="d-flex align-items-center">
                                <label htmlFor="pdfUploader">
                                  <i
                                      className="fa fa-cloud-upload fa-2x clickable"
                                      style={{color: "rgba(53, 78, 128, 0.9)"}}
                                  ></i>
                                </label>
                                <input
                                    ref={fileInputRef}
                                    onChange={handleModalFileUpload}
                                    id="pdfUploader"
                                    type="file"
                                    className="d-none"
                                    accept="application/pdf"
                                />
                                <p
                                    title={demoObj.file}
                                    className="ml-2 mb-1 one-line-overflow-ellepse"
                                >
                                  {demoObj.file}
                                </p>
                              </div>
                            </div>
                            <button
                                type="button"
                                onClick={handleAdd}
                                className="save-btn btn-block"
                            >
                              add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isLoading && <DataLoader/>}
              {data && (
                  <InfiniteScroll
                      dataLength={data.length}
                      next={getData}
                      hasMore={hasMore}
                      loader={<DataLoader/>}
                  >
                    <div className="row mx-0 py-3">
                      {data.map((item) => (
                          <div key={item.id} className="col-xl-3 col-lg-4 col-md-6">
                            <div className="custom-act-rules-order-card">
                              <div className="card-header">
                                <img src={rulesImage} alt="Rules Icon"/>
                              </div>
                              <div className="card-body d-block text-left">
                                <div className="form__div-container w-100 mb-0">
                                  <div className="form__div">
                                    <input
                                        required
                                        type="text"
                                        name="titleEn"
                                        id="titleEn"
                                        maxLength="100"
                                        className="form__input"
                                        placeholder=" "
                                        onChange={(e) => handleTittleChange(e, item.id)}
                                        value={item.titleEn}
                                    />
                                    <label htmlFor="" className="form__label">
                                      Title
                                    </label>
                                  </div>
                                </div>
                                <div className="form__div-container w-100 my-3">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor={`pdfUploader${item.id}`}>
                                      <i
                                          className="fa fa-cloud-upload fa-2x clickable"
                                          style={{color: "rgba(53, 78, 128, 0.9)"}}
                                      ></i>
                                    </label>
                                    <input
                                        onChange={(e) => handleFileUpload(e, item.id)}
                                        id={`pdfUploader${item.id}`}
                                        type="file"
                                        className="d-none"
                                        accept="application/pdf"
                                    />
                                    <p
                                        title={item.fileTag}
                                        className="ml-2 mb-1 one-line-overflow-ellepse"
                                    >
                                      {item.fileTag}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="custom-card-footer">
                                <div className="d-flex align-items-center justify-content-center">
                                  <button
                                      onClick={() => handleDelete(item.id)}
                                      type="button"
                                      className="delete-btn"
                                  >
                                    Delete
                                  </button>
                                  <button
                                      type="button"
                                      onClick={() => handleUpdate(item.id)}
                                      className="save-btn ml-2"
                                  >
                                    save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                      ))}
                    </div>
                  </InfiniteScroll>
              )}
            </div>
          </div>
        </div>
      </section>
  );
};

export default Index;
